import { FILTERS } from '@mixtiles/web-backend-shared'

const CSS_FILTER_MAP: Partial<Record<FILTERS, string>> = {
  [FILTERS.NOIR]: 'grayscale(1) contrast(1.15) brightness(0.95)',
  [FILTERS.SILVER]: 'grayscale(1) contrast(1.05)',
  [FILTERS.MONO]: 'grayscale(1)',
  [FILTERS.DRAMATIC]: 'contrast(1.2) saturate(1.1) brightness(0.95)',
  [FILTERS.VIVID]: 'saturate(1.5) contrast(1.05)',
  [FILTERS.WINTER]: 'hue-rotate(-10deg) saturate(0.85) brightness(1.05)',
  [FILTERS.BRIGHT]: 'brightness(1.1) saturate(1.1)',
}

export function getCssFilter(filter: FILTERS): string {
  return CSS_FILTER_MAP[filter] ?? 'none'
}
